<template>
  <div>
    <pageTable 
      ref="table"
      :tableTitle="tableColumn"
      :searchData="searchData"
      tableApi="admin/shell_card/getLists"
    >
      <template v-slot:searchFormItem>
<!--        <FormItem prop="user_id">-->
<!--          <Input type="text" v-model="searchData.user_id" placeholder="用户ID" class="lx-search-item"></Input>-->
<!--        </FormItem>-->
        <FormItem prop="pan_code">
          <Input type="text" v-model="searchData.pan_code" placeholder="卡号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="status">
          <Select v-model="searchData.status" placeholder="状态" style="width: 120px;">
            <Option value="">全部</Option>
            <Option value="1">正常</Option>
            <Option value="0">禁用</Option>
          </Select>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="showAddDialog">添加卡片</Button>
        </FormItem>
        <FormItem>
          <Button type="warning" @click="showBatchImportDialog">批量导入</Button>
        </FormItem>
      </template>
    </pageTable>

    <!-- 编辑/添加对话框 -->
    <Modal
      v-model="showEditModal"
      :title="editMode === 'add' ? '添加卡片' : '编辑卡片'"
      width="600"
      :mask-closable="true"
    >
      <Form 
        ref="editForm" 
        :model="editFormData" 
        :rules="editFormRules"
        label-position="right"
        :label-width="120"
      >
        <FormItem label="Token" prop="shell_user_token">
          <Input 
            v-model="editFormData.shell_user_token" 
            type="textarea" 
            :rows="5"
            placeholder="Token字符串"
          />
        </FormItem>
        
        <FormItem label="卡号" prop="pan_code">
          <Input v-model="editFormData.pan_code" placeholder="请输入卡号" />
        </FormItem>
        
        <FormItem label="Shell用户ID">
          <Input v-model="editFormData.shell_user_id" placeholder="" />
        </FormItem>
        
        <FormItem label="手机号">
          <Input v-model="editFormData.cellphone" placeholder="请输入手机号" />
        </FormItem>
        
        <FormItem label="账户代码">
          <Input v-model="editFormData.account_code" placeholder="请输入账户代码" />
        </FormItem>
        
        <FormItem label="机构ID">
          <Input v-model="editFormData.org_id" placeholder="请输入机构ID" />
        </FormItem>
        
        <FormItem label="加密密码" prop="encrypted_password" required>
          <Input v-model="editFormData.encrypted_password" placeholder="加密密码（必填）" />
<!--          <div class="form-tip">提示：从抓包工具的 /purchases 请求中提取 password 字段，用于获取二维码</div>-->
        </FormItem>
        
        <FormItem label="状态">
          <RadioGroup v-model="editFormData.status">
            <Radio :label="1">正常</Radio>
            <Radio :label="0">禁用</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      
      <div slot="footer">
        <Button @click="cancelEdit">取消</Button>
        <Button type="primary" @click="saveCard" :loading="saveLoading">保存</Button>
      </div>
    </Modal>

    <!-- 详情对话框 -->
    <Modal
      v-model="showDetailModal"
      title="卡片详情"
      width="600"
    >
      <div v-if="detailData" class="detail-content">
        <p><strong>ID:</strong> {{ detailData.id }}</p>
        <p><strong>Shell用户ID:</strong> {{ detailData.shell_user_id || '-' }}</p>
        <p><strong>卡号:</strong> {{ detailData.pan_code }}</p>
        <p><strong>账户代码:</strong> {{ detailData.account_code || '-' }}</p>
        <p><strong>机构ID:</strong> {{ detailData.org_id }}</p>
        <p><strong>手机号:</strong> {{ detailData.cellphone || '-' }}</p>
        <p><strong>余额:</strong> ¥{{ parseFloat(detailData.balance).toFixed(2) }}</p>
        <p><strong>状态:</strong> 
          <Tag :color="detailData.status == 1 ? 'success' : 'error'">
            {{ detailData.status == 1 ? '正常' : '禁用' }}
          </Tag>
        </p>
        <p><strong>Token:</strong></p>
        <Input 
          v-model="detailData.shell_user_token" 
          type="textarea" 
          :rows="5"
          readonly
        />
        <p v-if="detailData.token_expire_time">
          <strong>Token过期时间:</strong> {{ detailData.token_expire_time }} 
          (剩余{{ detailData.token_days_remaining }}天)
        </p>
        <p v-if="detailData.locking_order_id > 0">
          <strong>锁定订单:</strong> {{ detailData.locking_order_id }}
        </p>
        <p v-if="detailData.lock_time">
          <strong>锁定时间:</strong> {{ detailData.lock_time }}
        </p>
        <p v-if="detailData.last_balance_check_time">
          <strong>最后余额检查时间:</strong> {{ detailData.last_balance_check_time }}
        </p>
        <p><strong>创建时间:</strong> {{ detailData.create_time }}</p>
        <p><strong>更新时间:</strong> {{ detailData.update_time }}</p>
      </div>
    </Modal>

    <!-- 批量导入对话框 -->
    <Modal
      v-model="showBatchImportModal"
      title="批量导入"
      width="700"
    >
      <Form label-position="right" :label-width="120">
        <FormItem label="默认用户ID">
          <Input 
            v-model="batchImportData.defaultUserId" 
            placeholder="如果JSON中没有user_id，使用此值" 
          />
        </FormItem>
        
        <FormItem label="JSON数据" required>
          <Input 
            v-model="batchImportData.jsonData" 
            type="textarea" 
            :rows="15"
            placeholder='[{"token":"...","pan_code":"...","user_id":12345}]'
          />
        </FormItem>
      </Form>
      
      <div slot="footer">
        <Button @click="cancelBatchImport">取消</Button>
        <Button type="primary" @click="submitBatchImport" :loading="importLoading">导入</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import pageTable from "@/components/table/pageTable";
import shellCardApi from "@/api/shellCard";

export default {
  name: "shell-card-lists",
  components: { pageTable },
  data() {
    return {
      // 搜索数据
      searchData: {
        user_id: '',
        pan_code: '',
        status: ''
      },
      
      // 表格列定义（在 created 中初始化以避免 this 指向问题）
      tableColumn: [],
      
      // 编辑相关
      showEditModal: false,
      editMode: 'add', // 'add' 或 'edit'
      editFormData: {
        id: '',
        user_id: '',
        shell_user_token: '',
        pan_code: '',
        shell_user_id: '',
        cellphone: '',
        account_code: '',
        org_id: '84840000',
        encrypted_password: '',
        status: 1
      },
      editFormRules: {
        shell_user_token: [
          { required: true, message: 'Token不能为空', trigger: 'blur' }
        ],
        pan_code: [
          { required: true, message: '卡号不能为空', trigger: 'blur' }
        ],
        encrypted_password: [
          { required: true, message: '加密密码不能为空', trigger: 'blur' }
        ]
      },
      saveLoading: false,
      
      // 详情相关
      showDetailModal: false,
      detailData: null,
      
      // 批量导入相关
      showBatchImportModal: false,
      batchImportData: {
        defaultUserId: '',
        jsonData: ''
      },
      importLoading: false
    };
  },
  created() {
    // 在 created 钩子中初始化表格列，确保 this 正确指向 Vue 实例
    this.tableColumn = [
      { title: 'ID', key: 'id', width: 60, sortable: true },
      //{ title: '用户ID', key: 'user_id', width: 80 },
      { title: 'Shell用户ID', key: 'shell_user_id', width: 100 },
      { title: '卡号', key: 'pan_code', width: 100 },
      { title: '账户代码', key: 'account_code', width: 110 },
      { title: '机构ID', key: 'org_id', width: 85 },
      { title: '手机号', key: 'cellphone', width: 130 },
      { 
        title: '加密密码', 
        key: 'encrypted_password', 
        width: 120,
        render: (h, params) => {
          const pwd = params.row.encrypted_password;
          return h('span', pwd ? pwd.substring(0, 6) + '***' : '未配置');
        }
      },
      { 
        title: 'Token', 
        key: 'shell_user_token_display', 
        width: 150,
        render: (h, params) => {
          return h('Tooltip', {
            props: {
              content: params.row.shell_user_token,
              placement: 'top',
              'max-width': 300
            }
          }, params.row.shell_user_token_display || '-');
        }
      },
      { 
        title: '余额', 
        key: 'balance', 
        width: 110,
        render: (h, params) => {
          return h('span', '¥' + parseFloat(params.row.balance || 0).toFixed(2));
        },
        sortable: true
      },
      { 
        title: 'Token有效期', 
        key: 'token_days_remaining', 
        width: 108,
        render: (h, params) => {
          const row = params.row;
          let className = 'token-normal';
          let text = row.token_days_remaining + '天';
          if (row.token_expired == 1) {
            className = 'token-expired';
            text = '已过期';
          } else if (row.token_days_remaining <= 3) {
            className = 'token-warning';
          }
          return h('span', { class: className }, text);
        },
        sortable: true
      },
      { 
        title: '锁定状态', 
        key: 'lock_status', 
        width: 85,
        render: (h, params) => {
          const row = params.row;
          let className = '';
          let text = row.lock_status;
          switch (row.lock_status) {
            case 'available':
              className = 'lock-status-available';
              text = '✓ 可用';
              break;
            case 'locked':
              className = 'lock-status-locked';
              text = ' 锁定';
              break;
            case 'timeout':
              className = 'lock-status-timeout';
              text = '⚠️ 超时';
              break;
          }
          return h('span', { class: className }, text);
        }
      },
      { 
        title: '状态', 
        key: 'status', 
        width: 85,
        render: (h, params) => {
          return h('Tag', {
            props: {
              color: params.row.status == 1 ? 'success' : 'error'
            }
          }, params.row.status == 1 ? '正常' : '禁用');
        }
      },
      { title: '创建时间', key: 'create_time', width: 110, sortable: true },
      { title: '更新时间', key: 'update_time', width: 110, sortable: true },
      { 
        title: '操作', 
        key: 'action',
        width: 220,
        align: 'center',
        fixed: 'right',
        render: (h, params) => {
          const row = params.row;
          const buttons = [];
          
          // 详情按钮
          buttons.push(h('Button', {
            props: { type: 'primary', size: 'small' },
            style: { marginRight: '5px' },
            on: { click: () => this.showDetail(row.id) }
          }, '详情'));
          
          // 编辑按钮
          buttons.push(h('Button', {
            props: { type: 'default', size: 'small' },
            style: { marginRight: '5px' },
            on: { click: () => this.showEditDialog(row) }
          }, '编辑'));
          
          // 解锁按钮（仅当锁定时显示）
          if (row.lock_status === 'locked' || row.lock_status === 'timeout') {
            buttons.push(h('Button', {
              props: { type: 'error', size: 'small' },
              style: { marginRight: '5px' },
              on: { click: () => this.unlockCard(row.id) }
            }, '解锁'));
          }
          
          // 同步余额按钮
          buttons.push(h('Button', {
            props: { type: 'warning', size: 'small' },
            style: { marginRight: '5px' },
            on: { click: () => this.syncBalance(row.id) }
          }, '同步余额'));
          
          // 启用/禁用按钮
          buttons.push(h('Button', {
            props: { 
              type: row.status == 1 ? 'default' : 'primary', 
              size: 'small' 
            },
            style: { marginRight: '5px' },
            on: { 
              click: () => this.setStatus(row.id, row.status == 1 ? 0 : 1) 
            }
          }, row.status == 1 ? '禁用' : '启用'));
          
          // 删除按钮
          buttons.push(h('Button', {
            props: { type: 'error', size: 'small' },
            on: { click: () => this.deleteCard(row.id) }
          }, '删除'));
          
          return h('div', buttons);
        }
      }
    ];
  },
  methods: {
    // 获取Token状态样式类
    getTokenStatusClass(row) {
      if (row.token_expired == 1) return 'token-expired';
      if (row.token_days_remaining <= 3) return 'token-warning';
      return 'token-normal';
    },
    
    // 获取Token状态文本
    getTokenStatusText(row) {
      if (row.token_expired == 1) return '已过期';
      return `${row.token_days_remaining}天`;
    },
    
    // 获取锁定状态样式类
    getLockStatusClass(status) {
      switch (status) {
        case 'available': return 'lock-status-available';
        case 'locked': return 'lock-status-locked';
        case 'timeout': return 'lock-status-timeout';
        default: return '';
      }
    },
    
    // 获取锁定状态文本
    getLockStatusText(row) {
      switch (row.lock_status) {
        case 'available': return '✓ 可用';
        case 'locked': return `🔒 锁定(${row.lock_minutes}分钟)`;
        case 'timeout': return `⚠️ 超时(${row.lock_minutes}分钟)`;
        default: return row.lock_status;
      }
    },
    
    // 显示添加对话框
    showAddDialog() {
      this.editMode = 'add';
      this.resetEditForm();
      this.$nextTick(() => {
        this.showEditModal = true;
      });
    },
    
    // 显示编辑对话框
    showEditDialog(data) {
      this.editMode = 'edit';
      this.editFormData = {
        id: data.id,
        user_id: data.user_id,
        shell_user_token: data.shell_user_token,
        pan_code: data.pan_code,
        shell_user_id: data.shell_user_id || '',
        cellphone: data.cellphone || '',
        account_code: data.account_code || '',
        org_id: data.org_id || '84840000',
        encrypted_password: data.encrypted_password || '',
        status: data.status
      };
      this.$nextTick(() => {
        this.showEditModal = true;
      });
    },
    
    // 重置编辑表单
    resetEditForm() {
      this.editFormData = {
        id: '',
        user_id: '',
        shell_user_token: '',
        pan_code: '',
        shell_user_id: '',
        cellphone: '',
        account_code: '',
        org_id: '84840000',
        encrypted_password: '',
        status: 1
      };
      this.$nextTick(() => {
        if (this.$refs.editForm) {
          this.$refs.editForm.resetFields();
        }
      });
    },
    
    // 取消编辑
    cancelEdit() {
      this.showEditModal = false;
      this.resetEditForm();
    },
    
    // 保存卡片
    async saveCard() {
      try {
        await this.$refs.editForm.validate();
        
        this.saveLoading = true;
        const res = await shellCardApi.save(this.editFormData);
        this.saveLoading = false;
        
        if (res.code === 200) {
          this.$Message.success(res.msg || '保存成功');
          this.showEditModal = false;
          this.resetEditForm();
          this.$refs.table.getLists();
        } else {
          this.$Message.error(res.msg || '保存失败');
        }
      } catch (error) {
        this.saveLoading = false;
        console.error('表单验证失败:', error);
      }
    },
    
    // 显示详情
    async showDetail(id) {
      const res = await shellCardApi.getDetail({ id });
      if (res.code === 200) {
        this.detailData = res.data;
        this.showDetailModal = true;
      } else {
        this.$Message.error(res.msg || '获取详情失败');
      }
    },
    
    // 解锁卡片
    unlockCard(id) {
      this.$Modal.confirm({
        title: '确认解锁',
        content: '确定要解锁此卡片吗？',
        onOk: async () => {
          const res = await shellCardApi.unlockCard({ id });
          if (res.code === 200) {
            this.$Message.success(res.msg || '解锁成功');
            this.$refs.table.getLists();
          } else {
            this.$Message.error(res.msg || '解锁失败');
          }
        }
      });
    },
    
    // 同步余额
    async syncBalance(id) {
      this.$Spin.show();
      const res = await shellCardApi.syncBalance({ id });
      this.$Spin.hide();
      
      if (res.code === 200) {
        this.$Message.success(`同步成功，余额: ¥${parseFloat(res.data.balance).toFixed(2)}`);
        this.$refs.table.getLists();
      } else {
        this.$Message.error(res.msg || '同步失败');
      }
    },
    
    // 设置状态
    setStatus(id, status) {
      const action = status === 1 ? '启用' : '禁用';
      this.$Modal.confirm({
        title: `确认${action}`,
        content: `确定要${action}此卡片吗？`,
        onOk: async () => {
          const res = await shellCardApi.setStatus({ id, status });
          if (res.code === 200) {
            this.$Message.success(res.msg || '操作成功');
            this.$refs.table.getLists();
          } else {
            this.$Message.error(res.msg || '操作失败');
          }
        }
      });
    },
    
    // 删除卡片
    deleteCard(id) {
      this.$Modal.confirm({
        title: '警告',
        content: '确定要删除此卡片吗？删除后不可恢复！',
        onOk: async () => {
          const res = await shellCardApi.delete({ id });
          if (res.code === 200) {
            this.$Message.success(res.msg || '删除成功');
            this.$refs.table.getLists();
          } else {
            this.$Message.error(res.msg || '删除失败');
          }
        }
      });
    },
    
    // 显示批量导入对话框
    showBatchImportDialog() {
      this.batchImportData = {
        defaultUserId: '',
        jsonData: ''
      };
      this.showBatchImportModal = true;
    },
    
    // 取消批量导入
    cancelBatchImport() {
      this.showBatchImportModal = false;
      this.batchImportData = {
        defaultUserId: '',
        jsonData: ''
      };
    },
    
    // 提交批量导入
    async submitBatchImport() {
      if (!this.batchImportData.jsonData) {
        this.$Message.error('请输入JSON数据');
        return;
      }
      
      this.importLoading = true;
      const res = await shellCardApi.batchImport({
        json_data: this.batchImportData.jsonData,
        default_user_id: this.batchImportData.defaultUserId
      });
      this.importLoading = false;
      
      if (res.code === 200) {
        let msg = res.msg || '导入成功';
        if (res.data && res.data.errors && res.data.errors.length > 0) {
          msg += '<br><br>错误信息:<br>' + res.data.errors.join('<br>');
        }
        this.$Modal.info({
          title: '导入结果',
          content: msg
        });
        this.cancelBatchImport();
        this.$refs.table.getLists();
      } else {
        this.$Message.error(res.msg || '导入失败');
      }
    }
  }
};
</script>

<style scoped lang="less">
.token-expired { 
  color: #ff5722; 
  font-weight: bold; 
}

.token-warning { 
  color: #ffb800; 
}

.token-normal { 
  color: #5fb878; 
}

.lock-status-locked { 
  color: #ff5722; 
}

.lock-status-timeout { 
  color: #ff9800; 
}

.lock-status-available { 
  color: #5fb878; 
}

.form-tip {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}

.detail-content {
  p {
    margin-bottom: 10px;
    line-height: 1.6;
    
    strong {
      display: inline-block;
      width: 120px;
      font-weight: bold;
    }
  }
}
</style>
